<template>
  <div class="scan-update-items">
    <div class="scan-search">
      <div class="scan-search-group">
        <div class="box">
          <PgScanInputCode
            ref="scanCodeRef"
            :placeholder="scanPlaceholder"
            @on-scan="onScan"
          ></PgScanInputCode>
        </div>
        <div class="or">或</div>
        <div class="box">
          <PgScanInputSearch
            ref="inputSearchRef"
            :placeholder="searchPlaceholder"
            @change="(c) => onInputSearch(c, true)"
          ></PgScanInputSearch>
        </div>
      </div>
      <div class="error-tip">
        <span v-if="errorMessage">{{ errorMessage }}</span>
      </div>
    </div>
    <div class="items-table">
      <PgTable
        class="items-table__table"
        ref="tableRef"
        height="auto"
        :dataUrl="itemsUrl"
        :dataParameters="itemsParameters"
        :columnTableCode="columnTableCode"
        :isSelection="isSelection"
        :showPagination="showPagination"
        @checkbox-change="checkboxChange"
        @checkbox-all="checkboxAll"
        @loaded-async="onLoadedAsync"
      >
      </PgTable>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import { isEqual, getValueByPath } from 'pangu-core'
import { PgScanInputCode, PgScanInputSearch } from '../components/index'
import { PgTable } from '../../table/index'
import { useSelected } from '../hook/use-selected'

const emit = defineEmits(['input'])

const props = defineProps({
  formModel: { type: Object },
  currentList: { type: Array },
  scanPlaceholder: { type: String, default: '请扫描序列号' },
  searchPlaceholder: { type: String, default: '搜索序列号' },
  itemsUrl: { type: String },
  itemsParameters: { type: Object },
  // Table Props
  columnTableCode: { type: String, default: '' },
  isSelection: { type: Boolean, default: false },
  isEpc: Boolean,
  valKey: String,
  showPagination: { type: Boolean, default: false },
})

const errorMessage = ref('')
// PgTable 的 ref
const tableRef = ref(null)

const {
  selected,
  serialNumbers,
  data,
  checkboxChange,
  checkboxAll,
  setCheckboxRow,
  saveAllSerialStorage,
  getTableData,
} = useSelected({
  props,
  tableRef,
})

const scanCodeRef = ref(null)
const onScan = (resData, { origin }) => {
  const serialNumber = props.isEpc ? origin : getValueByPath(resData, 'serialNumber.code')
  const msg = onSearch(serialNumber, true)
  if (!msg) {
    scanCodeRef.value.clearInput()
  }
}
const inputSearchRef = ref(null)
const onInputSearch = (serialNumber, isErrorTip) => {
  const msg = onSearch(serialNumber, isErrorTip)
  if (!msg) {
    inputSearchRef.value.onClear()
  }
}
const onSearch = (serialNumber, isErrorTip) => {
  const { fullData } = getTableData()
  let msg = `系统找不到此${props.isEpc ? '自定义序列号' : '序列号'}`
  for (const row of fullData) {
    const checked = isEqual(serialNumber, getValueByPath(row, props.valKey))

    if (checked) {
      // 匹配到序列号
      setCheckboxRow(row, checked)
      msg = ''
    }
  }

  if (isErrorTip) errorMessage.value = msg
  return msg
}

const onLoadedAsync = async (fullData) => {
  for (const row of fullData) {
    if (serialNumbers.value.includes(getValueByPath(row, props.valKey))) {
      setCheckboxRow(row, true)
    }
  }
}

watch(
  () => selected.value,
  (val) => {
    const items = val.reduce((prev, id) => {
      if (data.get(id)) prev.push(data.get(id))
      return [...new Set(prev)]
    }, [])
    emit('input', { selected: val, items })
  },
  { deep: true }
)
watch(
  () => props.currentList,
  (list) => {
    saveAllSerialStorage(list)
    list.forEach((c) => onSearch(c))
  },
  { immediate: true }
)
</script>

<style lang="scss">
@import '../style/scan-update-items.scss';
</style>
